/**
 * Loading Animation Utility
 * Thin wrapper around window.showLoader() / window.hideLoader().
 * The global functions are defined in kassieLoaderV3.js and do direct DOM manipulation.
 */

/**
 * Start the Kassie loading animation.
 * Initializes the animated loader if needed, then shows it.
 * @returns {null}
 */
export async function startLoadingAnimation() {
  try {
    // Ensure the Kassie loader V3 DOM is initialized (only runs once)
    const { initKassieLoaderV3 } = await import('./kassieLoaderV3.js');
    await initKassieLoaderV3();
  } catch (err) {
    console.error('❌ Failed to init Kassie loader:', err);
  }

  // Show via global — direct DOM, cannot fail
  window.showLoader();
  return null;
}

/**
 * Stop the Kassie loading animation.
 */
export async function stopLoadingAnimation() {
  window.hideLoader();
}
